import * as React from 'react';
import { SVGProps } from 'react';

const IconUnlockSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 7a3 3 0 0 1 6 0v3H7.25C6.56 10 6 10.551 6 11.23v13.54c0 .679.56 1.23 1.25 1.23h17.5c.69 0 1.25-.551 1.25-1.23V11.23c0-.679-.56-1.23-1.25-1.23H12V7A5 5 0 0 0 2 7v1h2V7Zm12.79 10.874a2.466 2.466 0 0 0 1.71-2.335c0-1.36-1.12-2.462-2.5-2.462s-2.5 1.102-2.5 2.462c0 1.087.716 2.01 1.71 2.335l-1.71 5.05h5l-1.71-5.05Z"
    />
  </svg>
);
export default IconUnlockSizeL;
